// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__Q7fKT","description":"MealItem_description__gmGgS","price":"MealItem_price__KPb-R"};